import React, { FC, ReactNode } from 'react';

import { Icon } from '@column/column-ui-kit';
import { DialogClose, DialogHeader, DialogTitle } from '@column/ui';

interface DialogHeaderWithCloseProps {
  title: ReactNode;
  disabled?: boolean;
}

export const DialogHeaderWithClose: FC<DialogHeaderWithCloseProps> = ({ title, disabled }) => (
  <DialogHeader className="-mx-6 -mt-2 flex-row items-start justify-between gap-4 border-b border-gray-100 px-6 pb-4 dark:border-white/[0.08]">
    <DialogTitle>{title}</DialogTitle>
    <DialogClose asChild>
      <button
        type="button"
        aria-label="Close"
        disabled={disabled}
        className="-my-0.5 -mr-1 flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-gray-100 hover:text-foreground disabled:pointer-events-none disabled:opacity-50 dark:hover:bg-white/10"
      >
        <Icon.Close className="[--icon-size-x:16px] [--icon-size-y:16px]" />
      </button>
    </DialogClose>
  </DialogHeader>
);
